<template>
  <Modal ref="modalRef" class="notice" v-bind="$attrs" v-on="$listeners">
    <div>
      <p class="notice-content">
        {{ languages.updateVersionPopupContent }}
      </p>
    </div>
    <div class="notice-footer">
      <Button class="notice-footer-cancel" @click="closePopup">
        {{ languages.smartOrderIKnow }}
      </Button>
    </div>
  </Modal>
</template>

<script>
export default {
  props: ['languages'],
  data() {
    return {
      operateType: '',
      activePage: 1
    };
  },
  methods: {
    closePopup() {
      this.$refs?.modalRef?.closeModal();
    },
    updatePage(page) {
      this.activePage = page;
    }
  }
};
</script>

<style lang="scss" scoped>
.notice {
  &-content {
    margin-top: 20px;
    line-height: 20px;
    margin-bottom: 30px;
    font-size: 14px;
    color: #666666;
    min-height: 80px;
  }

  &-footer {
    &-cancel {
      width: 100%;
      flex: 1;
      height: 50px !important;
      border-radius: 6px !important;
      font-size: 18px !important;
    }
  }
}
</style>
